"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipClear = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _BrowserDefaultFocusStyleContext = require("../../contexts/BrowserDefaultFocusStyleContext.js");
var _EncoreContext = require("../../contexts/EncoreContext.js");
var _KeyboardDetectionContext = require("../../contexts/KeyboardDetectionContext.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../Chip/index.js");
var _index2 = require("../Icon/icons/IconX/index.js");
var _ChipClear = require("./ChipClear.js");
var _excluded = ["size"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * The chip clear button is used to clear the applied filters from selected chips.
 *
 * This component is being phased out. We recommend instead using "Next" Chip with the props `iconLeading={IconX}` and `aria-label="Clear filters"`.
 * This component cannot be used within a `ChipGroup` or under an EncoreProvider with `Next` lifecycle.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-chip-chipclear--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ChipClear)
 */
var ChipClear = exports.ChipClear = /*#__PURE__*/_react["default"].forwardRef(function ChipClear(_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_KeyboardDetectionContext.KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = (0, _react.useContext)(_BrowserDefaultFocusStyleContext.BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  var config = (0, _react.useContext)(_EncoreContext.EncoreContext);
  var status = (0, _EncoreContext.getStatus)(_EncoreContext.encoreContextKeyword.chip, config);
  var iconSize = size === 'sm' ? 'small' : 'medium';
  if (status === 'next') {
    return /*#__PURE__*/_react["default"].createElement(_index.Chip, Object.assign({
      ref: ref,
      size: size,
      iconLeading: _index2.IconX
    }, props, {
      "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.ChipClear
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_ChipClear.ChipClearComponent, Object.assign({
    ref: ref,
    $size: size,
    $isUsingKeyboard: isUsingKeyboard,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.ChipClear
  }), /*#__PURE__*/_react["default"].createElement(_index2.IconX, {
    size: iconSize,
    "aria-hidden": "true"
  }));
});